import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../components/ui/Card';
import { Textarea } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { Copy, Check } from 'lucide-react';
export function CaseConverter() {
  const [inputText, setInputText] = useState('');
  const [outputText, setOutputText] = useState('');
  const [copied, setCopied] = useState(false);
  const convertCase = (type: string) => {
    let result = '';
    switch (type) {
      case 'upper':
        result = inputText.toUpperCase();
        break;
      case 'lower':
        result = inputText.toLowerCase();
        break;
      case 'title':
        result = inputText.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
        break;
      case 'sentence':
        result = inputText.toLowerCase().replace(/(^\s*\w|[.!?]\s*\w)/g, char => char.toUpperCase());
        break;
      case 'camel':
        result = inputText.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (_, char) => char.toUpperCase());
        break;
      case 'snake':
        result = inputText.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
        break;
      default:
        result = inputText;
    }
    setOutputText(result);
  };
  const copyToClipboard = () => {
    navigator.clipboard.writeText(outputText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="container mx-auto px-4 py-8 max-w-4xl" data-id="element-640">
      <div className="mb-8" data-id="element-641">
        <h1 className="text-4xl font-bold mb-2" data-id="element-642">Case Converter</h1>
        <p className="text-muted-foreground" data-id="element-643">
          Convert text to different cases instantly
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6" data-id="element-644">
        <Card data-id="element-645">
          <CardHeader data-id="element-646">
            <CardTitle data-id="element-647">Input Text</CardTitle>
            <CardDescription data-id="element-648">
              Enter the text you want to convert
            </CardDescription>
          </CardHeader>
          <CardContent data-id="element-649">
            <Textarea value={inputText} onChange={e => setInputText(e.target.value)} placeholder="Type or paste your text here..." rows={6} data-id="element-650" />
          </CardContent>
        </Card>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-651">
          <Button onClick={() => convertCase('upper')} variant="outline" data-id="element-652">
            UPPERCASE
          </Button>
          <Button onClick={() => convertCase('lower')} variant="outline" data-id="element-653">
            lowercase
          </Button>
          <Button onClick={() => convertCase('title')} variant="outline" data-id="element-654">
            Title Case
          </Button>
          <Button onClick={() => convertCase('sentence')} variant="outline" data-id="element-655">
            Sentence case
          </Button>
          <Button onClick={() => convertCase('camel')} variant="outline" data-id="element-656">
            camelCase
          </Button>
          <Button onClick={() => convertCase('snake')} variant="outline" data-id="element-657">
            snake_case
          </Button>
        </div>

        {outputText && <Card data-id="element-658">
            <CardHeader data-id="element-659">
              <div className="flex items-center justify-between" data-id="element-660">
                <div data-id="element-661">
                  <CardTitle data-id="element-662">Output</CardTitle>
                  <CardDescription data-id="element-663">Converted text</CardDescription>
                </div>
                <Button onClick={copyToClipboard} variant="outline" size="sm" data-id="element-664">
                  {copied ? <Check className="w-4 h-4 mr-2" data-id="element-665" /> : <Copy className="w-4 h-4 mr-2" data-id="element-666" />}
                  {copied ? 'Copied!' : 'Copy'}
                </Button>
              </div>
            </CardHeader>
            <CardContent data-id="element-667">
              <div className="p-4 bg-muted rounded-lg font-mono text-sm whitespace-pre-wrap break-words" data-id="element-668">
                {outputText}
              </div>
            </CardContent>
          </Card>}
      </div>
    </div>;
}